import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { faPrint, faRemove } from '@fortawesome/free-solid-svg-icons';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import AdvanceTable from 'components/base/AdvanceTable';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { addService, getService } from 'services/services';
import { dateFormat, formatDate, formatDateForAPI } from 'helpers/utils';
import DatePicker from 'components/base/DatePicker';
import JsonToCsvButton from 'components/JsonToCsvButton';
import Loader from 'helpers/Loader';

interface Project {
  id: number;
  status: string;
  invoice_no: number;
  invoice_date: string;
  invoice_amt: string;
  gst_amt: string;
  balance_amt: string;
  paid_amt: string;
  supplier: {
    supplier_name: string;
    status: string;
  };
}

interface DateTo {
  toDate: any;
  fromDate: any;
}

interface Field {
  site_id: number;
  expense_id: string;
  amount: string;
  paid_amount: string;
  comments: string;
  mode_of_payment: string;
  expenses_date: any;
  status: any;
  bill_doc: any;
}

const GstReportTable = () => {
  const [gstList, setGstList] = useState([]);
  const [supplierName, setSupplierName] = useState<any>([]);
  const [invoiceList, setInvoiceList] = useState<any>([]);
  const [balanceAmt, setBalanceAmt] = useState<number>(0);
  const [paidAmt, setPaidAmt] = useState<number>(0);
  const [gstAmt, setGstAmt] = useState<number>(0);
  const [invoiceAmt, setInvoiceAmt] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [invoiceNo, setInvoiceNo] = useState('');
  const [flag, setFlag] = useState('');
  const [supplierId, setSupplierId] = useState('');
  const [toDate, setToDate] = useState<any>('');
  const [fromDate, setFromDate] = useState<any>('');

  const filteredData = gstList.map((data: any) => ({
    Invoice_no: data.invoice_no,
    Invoice_date: data.invoice_date,
    Invoice_amt: data.invoice_amt,
    Gst_amt: data.gst_amt,
    Paid_amt: data.paid_amt,
    Balance_amt: data.balance_amt,
    Gst_status: data.status == 0 ? 'Pending' : 'Claim',
    Supplier: data.supplier.supplier_name,
    Mobile_no: data.supplier.mobile_no,
    Gst_no: data.supplier.gst_no,
    Pancard_no: data.supplier.pancard_no,
    Address: data.supplier.address,
    Bank_name: data.supplier.bank_name,
    Ifsc_code: data.supplier.ifsc_code,
    Account_no: data.supplier.account_no
  }));

  // const [fields, setFields] = useState<DateTo>({
  //   toDate: '',
  //   fromDate: ''
  // });

  // const toDate = fields.toDate ? formatDateForAPI(fields.toDate) : '';
  // const fromDate = fields.fromDate ? formatDateForAPI(fields.fromDate) : '';

  const grandTotal = (data: any) => {
    if (data != 'avark') {
      // Initialize totals
      const totals = data.reduce(
        (
          accumulator: {
            invoiceAmount: number;
            gstAmount: number;
            paidAmount: number;
            balanceAmount: number;
          },
          item: any
        ) => {
          return {
            invoiceAmount:
              accumulator.invoiceAmount + parseFloat(item.invoice_amt || '0'),
            gstAmount: accumulator.gstAmount + parseFloat(item.gst_amt || '0'),
            paidAmount:
              accumulator.paidAmount + parseFloat(item.paid_amt || '0'),
            balanceAmount:
              accumulator.balanceAmount + parseFloat(item.balance_amt || '0')
          };
        },
        { invoiceAmount: 0, gstAmount: 0, paidAmount: 0, balanceAmount: 0 }
      );

      setInvoiceAmt(totals.invoiceAmount.toFixed(2));
      setGstAmt(totals.gstAmount.toFixed(2));
      setPaidAmt(totals.paidAmount.toFixed(2));
      setBalanceAmt(totals.balanceAmount.toFixed(2));
    } else {
      setInvoiceAmt(0.0);
      setGstAmt(0.0);
      setPaidAmt(0.0);
      setBalanceAmt(0.0);
    }
  };

  const handleGst = async () => {
    const response = await getService(
      `supplier_invoice_gst_list/${toDate}/${fromDate}`
    );
    if (response.status === 200) {
      setGstList(response.data);
      grandTotal(response.data);
    } else {
      setGstList([]);
      grandTotal('avark');
    }
  };

  // const clearToDate = (event: any) => {
  //   event.preventDefault();
  //   setFields({
  //     ...fields,
  //     toDate: ''
  //   });
  //   fetch();
  // };
  // const clearFromDate = (event: any) => {
  //   event.preventDefault();
  //   setFields({
  //     ...fields,
  //     fromDate: ''
  //   });
  //   fetch();
  // };

  useEffect(() => {
    fetch();
    fetchSupplier();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      const response = await getService('supplier_invoice_gst_list');
      if (response.status === 200) {
        setLoading(false);
        setGstList(response.data);
        grandTotal(response.data);
        setInvoiceList(response.data);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };
  const fetchSupplier = async () => {
    try {
      setLoading(true);
      const response = await getService('supplier');
      if (response.status === 200) {
        setLoading(false);
        setSupplierName(response.data);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  const handleGSTStatusChange = async (event: any, id: any) => {
    try {
      setLoading(true);
      const response = await addService(
        `update_status_supplier_invoice/${id}`,
        {
          status: event.target.value
        }
      );
      if (response.status === 200) {
        setLoading(false);
        fetch();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    const fetchFiltered = async () => {
      const obj = {
        invoice_no: invoiceNo || null,
        flag: flag || null,
        supplier_id: supplierId || null,
        from_date: toDate || null,
        to_date: fromDate || null
      };

      try {
        const response = await addService(
          'supplier_invoice_gst_list_post_filter',
          obj
        );
        if (response.status === 200) {
          setGstList(response.data);
        } else {
          setGstList([]);
        }
      } catch (error) {
        console.error('Error fetching filtered data:', error);
        setGstList([]);
      }
    };
    if (supplierId || flag || invoiceNo || fromDate || toDate) {
      fetchFiltered();
    }
  }, [supplierId, flag, invoiceNo, fromDate, toDate]);

  const handleFilter = (data: any, name: string) => {
    if (name === 'supplier') setSupplierId(data);
    if (name === 'invoice') setInvoiceNo(data);
    if (name === 'flag') setFlag(data);
    if (name === 'fromDate') setFromDate(formatDateForAPI(data));
    if (name === 'toDate') setToDate(formatDateForAPI(data));
  };
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const membersTablecolumns: ColumnDef<Project>[] = [
    {
      accessorKey: 'supplier_name',
      header: '#',
      cell: ({ row: { original } }) => {
        const { status } = original;

        // Determine the colors for the dots
        const dotColors = {
          '0': 'red',
          '1': 'green'
        };

        // Default colors for two dots
        let colors = [];

        // Check for multiple statuses
        if (status.toString() === '0') {
          colors = [dotColors['0']];
        } else {
          colors = [dotColors['1']];
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {colors.map((color: any, index: any) => (
              <div
                key={index}
                style={{
                  backgroundColor: color,
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  marginRight: '4px' // Space between the dots
                }}
              ></div>
            ))}
          </div>
        );
      },
      meta: {
        headerProps: {
          style: { width: '5%', minWidth: '100px' },
          className: 'px-1'
        },
        cellProps: { className: 'align-middle white-space-nowrap py-2' }
      }
    },
    {
      accessorKey: 'actions',
      header: 'GST STATUS',
      cell: ({ row: { original } }) => {
        const { status, id } = original;
        return (
          <Row className="g-0">
            <Col xs={12} sm={9} md={7} lg={5} xl={4}>
              {/* <select className="form-select w-100"> */}
              <select
                value={status}
                onChange={event => handleGSTStatusChange(event, id)}
              >
                <option value={0}>Pending</option>
                <option value={1}>Claimed</option>
              </select>
            </Col>
          </Row>
        );
      },
      meta: {
        headerProps: { style: { width: '12%' } },
        cellProps: { className: 'ps-3 py-4' }
      }
    },
    {
      accessorKey: 'invoice_no',
      header: 'Invoice no',
      cell: ({ row: { original } }) => {
        const { invoice_no } = original;
        return (
          // <Link to="#!" className="d-flex align-items-center text-body">
          <Link to="#!" className="">
            {/* <p className="mb-0 ms-3 text-body-emphasis fw-semibold"> */}
            <p className="mb-0 fw-bold">{invoice_no}</p>
          </Link>
        );
      },
      meta: {
        // cellProps: { className: 'ps-3 text-body py-4' },
        // headerProps: { style: { width: '10%' } }
      }
    },
    {
      accessorKey: 'invoice_date',
      header: 'Invoice date',
      cell: ({ row: { original } }) => {
        const { invoice_date } = original;
        return (
          <span className="text-body-secondary fs-9 mb-0">
            {invoice_date ? dateFormat(invoice_date) : ''}
          </span>
        );
      },
      meta: {
        headerProps: { style: { width: '12%' } },
        cellProps: { className: 'text-body' }
      }
    },
    {
      accessorKey: 'supplier.supplier_name',
      header: 'Supplier name',
      meta: {
        cellProps: { className: 'ps-3 text-body py-4' },
        headerProps: { style: { width: '12%' } }
      }
    },
    {
      accessorKey: 'invoice_amt',
      header: 'Invoice amount',
      meta: {
        cellProps: { className: 'ps-3 text-body py-4' },
        headerProps: { style: { width: '12%' } }
      }
    },
    {
      accessorKey: 'gst_amt',
      header: 'GST Amount',
      meta: {
        cellProps: { className: 'ps-3 text-body py-4' },
        headerProps: { style: { width: '12%' } }
      }
    },
    {
      accessorKey: 'paid_amt',
      header: 'Paid amount',
      meta: {
        cellProps: { className: 'ps-3 text-body py-4' },
        headerProps: { style: { width: '10%' } }
      }
    },
    {
      accessorKey: 'balance_amt',
      header: 'Balance amount',
      meta: {
        cellProps: { className: 'ps-3 text-body py-4' },
        headerProps: { style: { width: '10%' } }
      }
    }
  ];

  const table = useAdvanceTable({
    data: gstList,
    columns: membersTablecolumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: true
  });
  if (loading) return <Loader />;
  return (
    <div>
      <div className="mb-9">
        <h4 className="mb-5">GST Report Table</h4>
        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <Row className="g-3">
              <Col xs="auto">
                <SearchBox
                  placeholder="Search...."
                  onChange={handleSearchInputChange}
                />
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  onChange={e => handleFilter(e.target.value, 'flag')}
                >
                  <option value="2">Select Flag</option>
                  <option value="1">Claim</option>
                  <option value="0">Pending</option>
                </Form.Select>
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  onChange={e => handleFilter(e.target.value, 'invoice')}
                >
                  <option value="0">Select Invoice</option>
                  {invoiceList.length > 0 &&
                    [
                      ...new Map(
                        invoiceList.map((item: any) => [item.invoice_no, item])
                      ).values()
                    ].map((item: any) => (
                      <option key={item.id} value={item.invoice_no}>
                        {item.invoice_no}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  onChange={e => handleFilter(e.target.value, 'supplier')}
                >
                  <option value="0">Select Supplier</option>
                  {supplierName.length > 0 &&
                    supplierName.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.supplier_name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              <Col xs="auto">
                <DatePicker
                  value={toDate}
                  options={{ enableTime: false, dateFormat: 'Y-m-d' }}
                  onChange={date => handleFilter(date, 'toDate')}
                  render={(_, ref) => {
                    return (
                      <Form.Floating>
                        <Form.Control
                          type="text"
                          placeholder="Project title"
                          ref={ref}
                          id="startDate"
                        />
                        <label htmlFor="startDate" className="ps-6">
                          To date
                        </label>
                      </Form.Floating>
                    );
                  }}
                />
                {/* {fields.toDate && (
                  <Col>
                    <span
                      onClick={clearToDate}
                      style={{
                        position: 'relative',
                        bottom: 34,
                        left: 180,
                        cursor: 'pointer'
                      }}
                    >
                      <FontAwesomeIcon icon={faRemove} className="me-sm-2" />
                    </span>
                  </Col>
                )} */}
              </Col>
              <Col xs="auto">
                <DatePicker
                  value={fromDate}
                  options={{ enableTime: false, dateFormat: 'Y-m-d' }}
                  // onChange={([date]) => {
                  //   setFromDate(formatDateForAPI(date));
                  // }}
                  onChange={date => handleFilter(date, 'fromDate')}
                  render={(_, ref) => {
                    return (
                      <Form.Floating>
                        <Form.Control
                          type="text"
                          placeholder="Project title"
                          ref={ref}
                          id="startDate"
                        />
                        <label htmlFor="startDate" className="ps-6">
                          From date
                        </label>
                      </Form.Floating>
                    );
                  }}
                />
                {/* {fields.fromDate && (
                  <Col xs="auto">
                    <span
                      onClick={clearFromDate}
                      style={{
                        position: 'relative',
                        bottom: 34,
                        left: 180,
                        cursor: 'pointer'
                      }}
                    >
                      <FontAwesomeIcon icon={faRemove} className="me-sm-2" />
                    </span>
                  </Col>
                )} */}
              </Col>
              {/* {fields.fromDate && fields.toDate && (
                <Col xs="auto">
                  <Button
                    onClick={handleGst}
                    variant="primary"
                    className="px-5"
                  >
                    Apply
                  </Button>
                </Col>
              )} */}
              {gstList.length > 0 && (
                <Col xs="auto" className="py-2">
                  <Row className="text-center">
                    <Col>
                      <h6 style={{ color: '#007bff' }}>Invoice AMT</h6>{' '}
                      <p className="fw-bold">{invoiceAmt}</p>
                    </Col>
                    <Col>
                      <h6 style={{ color: '#28a745' }}>GST AMT</h6>{' '}
                      <p className="fw-bold">{gstAmt}</p>
                    </Col>
                    <Col>
                      <h6 style={{ color: '#dc3545' }}>Paid AMT</h6>{' '}
                      <p className="fw-bold">{paidAmt}</p>
                    </Col>
                    <Col>
                      <h6 style={{ color: 'purple' }}>Balance AMT</h6>{' '}
                      <p className="fw-bold">{balanceAmt}</p>
                    </Col>
                  </Row>
                </Col>
              )}

              <Col
                xs="auto"
                className="scrollbar overflow-hidden-y flex-grow-1"
              ></Col>

              <Col xs="auto">
                <JsonToCsvButton
                  data={filteredData}
                  filename="GST Report.csv"
                />
                {/* <Button
                  onClick={() => console.log('clicked')}
                  variant="primary"
                  className="px-5"
                >
                  <FontAwesomeIcon icon={faPrint} className="me-2" />
                  Print
                </Button> */}
              </Col>
            </Row>
          </div>

          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
            <MembersTable />
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export const MembersTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
};

export default GstReportTable;
